/* eslint-disable no-console,indent */
import React from 'react';
import {ErrorNotification, AsyncButton} from '@nike/ruxac';
import {setSeasonFilter,
    setTestRequestIdFilter,
    setSuppliedMaterialIdentifierFilter,
    setNikePPSItemNumberFilter,
    setTestTypeFilter,
    setMsEndUseFilter,
    setMaterialTypeFilter,
    setSupplierLocationFilter,
    setLabFilter,
    setLabStateTestFilter,
    setLabTestStatusFilter,
    setFilters,
    clearFilterSelection
} from '../Actions/filters';
import {setLoadingIndicator,setNoSelectFilter} from '../Actions/loading';
import {connect} from 'react-redux';
import {loadDataFromAPI,
    //cacheSearchResults,
    loadTestRequestIdFilterAPI,
    loadSuppliedMaterialNumberAPI,
    loadNikePPSItemNumberAPI,
    loadTestRequestSeasonAPI,
    loadTestTypeAPI,
    loadEndUseAPI,
    loadMaterialTypeAPI,
    loadSuppliedLocationAPI,
    loadLabAPI,
    loadLabTestStateAPI,
    loadLabTestStatusAPI} from '../APIs/dataHelper';
import {setSearchTimeStampAction} from '../Actions/userInfo';
import {loadDataAction,loadCacheDataAction,setDataCachedAction,setRowCount,setNewSearchAction} from '../Actions/data';
import PseudoAsyncSelect from "./PseudoAsyncSelect";
import moment from 'moment';
import _ from 'lodash';
export class Filters extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            reqMet        : false,
            matTypeLength : 250
        };
    }

    async setMatTypeOptions () {
        const data =  await loadMaterialTypeAPI(5);
        this.setState({matTypeLength : data.length});
        return data;
    }

    render() {
        const {filters} = {
            ...this.props
        };
        const closeNotification = () =>{
            this.props.setNoSelectFilter(false);
        };
        const submitFilters = () => {
                let emptyFilters = true;
                _.forEach(_.keys(this.props.filters), k => {
                    if (!_.isEmpty(this.props.filters[k]))
                        emptyFilters = false;
                });
                if(emptyFilters){
                    this.props.setNoSelectFilter(true);
                    setTimeout(function(){closeNotification(); }, 2000);
                }
                else{
                    this.props.setNoSelectFilter(false);
                    this.props.setDataCachedAction(false);
                    const searchTimestamp = moment().utc().format('YYYYMMDDhhmmss') + 'GMT';
                    this.props.setSearchTimeStampAction(searchTimestamp);
                }
        };
        const clearFilters = () => {
            this.props.clearFilterSelection();

        };
        const testRequestIdCount = filters.testRequestIdentifier !==  undefined ? filters.testRequestIdentifier.length :0;
        const smNumberCount = filters.suppliedMaterialIdentifier!==  undefined ? filters.suppliedMaterialIdentifier.length:0;
        const ppsItemNumberCount = filters.nikePPSItemNumber !==  undefined ? filters.nikePPSItemNumber.length:0;
        const seasonCount = filters.testSubmissionCycleYear !==  undefined ? filters.testSubmissionCycleYear.length:0;
        const endUseCount = filters.nikeMsEndUse !==  undefined ? filters.nikeMsEndUse.length :0;
        const materialTypeCount = filters.materialType !==  undefined ? filters.materialType.length :0;

        return (
            <div className={`filter-container-outer`}>
                <div className={`shadowBox`}>
                    <div className={'row  filter-container-inner'}>

                        <div className={`col-xs-3`}>
                            <label>TEST REQUEST ID<div className={`count`}>Count {testRequestIdCount }</div></label>
                            <PseudoAsyncSelect
                                name={`testRequestIdentifier`}
                                isMulti={true}
                                onOptionChange={selectedOption => {
                                    this.props.setTestRequestIdFilter(selectedOption);
                                }}
                                asyncOptions={() => {
                                    return loadTestRequestIdFilterAPI(5);
                                }}
                                value={filters.testRequestIdentifier ?  filters.testRequestIdentifier : null}
                                placeholder={`Select Test Request ID up to 20`}
                                maxSelectedOptions={20}
                                maxViewedOptions={50}
                            />
                        </div>
                        <div className={`col-xs-3`}>
                            <label>PCX SUPPLIED MATERIAL NUMBER <div className={`count`}>Count {smNumberCount }</div></label>
                            <PseudoAsyncSelect
                                name={`suppliedMaterialIdentifier`}
                                isMulti={true}
                                onOptionChange={selectedOptions => {
                                    this.props.setSuppliedMaterialIdentifierFilter(selectedOptions);
                                }}
                                asyncOptions={() => {
                                    return loadSuppliedMaterialNumberAPI(5);
                                }}
                                value={filters.suppliedMaterialIdentifier ? filters.suppliedMaterialIdentifier : null}
                                placeholder={`Select PCX Supplied Material Number up to 20`}
                                maxSelectedOptions={20}
                                maxViewedOptions={50}
                            />
                        </div>

                        <div className={`col-xs-3`}>
                            <label>PPS ITEM NUMBER <div className={`count`}>Count {ppsItemNumberCount}</div></label>
                            <PseudoAsyncSelect
                                name="nikePPSItemNumber"
                                isMulti={true}
                                onOptionChange={selectedOptions => {
                                    this.props.setNikePPSItemNumberFilter(selectedOptions);
                                }}
                                asyncOptions={() => {
                                    return loadNikePPSItemNumberAPI(5);
                                }}
                                value={filters.nikePPSItemNumber ? filters.nikePPSItemNumber : null}
                                placeholder={`Select PPS Item Number up to 20`}
                                maxSelectedOptions={20}
                                maxViewedOptions={50}
                            />
                        </div>

                        <div className={`col-xs-3`}>
                            <label>TEST REQUEST SEASON<div className={`count`}>Count {seasonCount}</div></label>
                            <PseudoAsyncSelect
                                name="testSubmissionCycleYear"
                                isMulti={true}
                                onOptionChange={selectedOptions => {
                                    this.props.setSeasonFilter(selectedOptions);
                                }}
                                asyncOptions={() => {
                                    return loadTestRequestSeasonAPI(5);
                                }}
                                value={filters.testSubmissionCycleYear ? filters.testSubmissionCycleYear : null }
                                placeholder={`Select Test Request Season up to 4`}
                                maxSelectedOptions={4}
                                maxViewedOptions={50}
                            />
                        </div>

                    </div>
                    <div className={'row topRowSpace filter-container-inner'}>
                        <div className={`col-xs-3`}>
                            <label>TEST TYPE</label>
                            <PseudoAsyncSelect
                            isMulti={true}
                            name="testSubmissionType"
                            onOptionChange={selectedOptions => {
                                this.props.setTestTypeFilter(selectedOptions);
                            }}
                            asyncOptions={() => {
                                return loadTestTypeAPI(5);
                            }}
                            value={filters.testSubmissionType ? filters.testSubmissionType : null}
                            placeholder={`Select Test Type`}
                            maxSelectedOptions={0}
                            maxViewedOptions={50}
                        />
                        </div>
                        <div className={`col-xs-3`}>
                            <label>END USE <div className={`count`}>Count {endUseCount}</div></label>
                            <PseudoAsyncSelect
                                name="nikeMsEndUse"
                                isMulti={true}
                                onOptionChange={selectedOptions => {
                                    this.props.setMsEndUseFilter(selectedOptions);
                                }}
                                asyncOptions={() => {
                                    return loadEndUseAPI(5);
                                }}
                                value={filters.nikeMsEndUse ? filters.nikeMsEndUse : null}
                                placeholder={`Select End Use up to 10`}
                                maxSelectedOptions={10}
                                maxViewedOptions={50}
                            />
                        </div>

                        <div className={`col-xs-3`}>
                            <label>MATERIAL TYPE <div className={`count`}>Count {materialTypeCount }</div></label>
                            <PseudoAsyncSelect
                                name="materialType"
                                isMulti={true}
                                onOptionChange={selectedOptions => {
                                    this.props.setMaterialTypeFilter(selectedOptions);
                                }}
                                asyncOptions={() => {
                                    const options = this.setMatTypeOptions();
                                    return options;
                                }}
                                value={filters.materialType ? filters.materialType : null}
                                placeholder={`Select Material Type up to 4`}
                                maxSelectedOptions={4}
                                maxViewedOptions={this.state.matTypeLength}
                            />
                        </div>
                        <div className={`col-xs-3`}>
                            <label>SUPPLIER LOCATION</label>
                            <PseudoAsyncSelect
                                name="supplierLocation"
                                isMulti={false}
                                onOptionChange={selectedOptions => {
                                    if(!selectedOptions || selectedOptions.length === 0) {
                                    this.props.setSupplierLocationFilter([]);
                                    }
                                    else{
                                        this.props.setSupplierLocationFilter([selectedOptions]);
                                    }
                                }}
                                asyncOptions={() => {
                                    return loadSuppliedLocationAPI(5);
                                }}
                                value={filters.supplierLocation ? filters.supplierLocation : null}
                                placeholder={`Select One Supplier Location`}
                                maxSelectedOptions={1}
                                maxViewedOptions={50}
                                isClearable={true}
                            />
                        </div>
                    </div>
                        <div className={`row filter-container-inner`}>
                            <div className={`col-xs-3`}>
                                <label>LAB</label>
                                <PseudoAsyncSelect
                                    name="testLabIdentifier"
                                    isMulti={false}
                                    onOptionChange={selectedOptions => {
                                        if(!selectedOptions || selectedOptions.length === 0) {
                                            this.props.setLabFilter([]);
                                        }else {
                                            this.props.setLabFilter([selectedOptions]);
                                        }
                                    }}
                                    asyncOptions={() => {
                                        return loadLabAPI(5);
                                    }}
                                    placeholder={`Select One Lab`}
                                    value={filters.testLabIdentifier ? filters.testLabIdentifier : null }
                                    maxSelectedOptions={1}
                                    maxViewedOptions={50}
                                    isClearable={true}
                                />
                            </div>
                            <div className={`col-xs-3`}>
                                <label>LAB TEST STATE</label>
                                <PseudoAsyncSelect
                                    name="labTestState"
                                    isMulti={false}
                                    onOptionChange={selectedOptions => {
                                        if(!selectedOptions || selectedOptions.length === 0) {
                                            this.props.setLabStateTestFilter([]);
                                        }
                                        else{
                                            this.props.setLabStateTestFilter([selectedOptions]);
                                        }
                                    }}
                                    asyncOptions={() => {
                                       return loadLabTestStateAPI(5);
                                    }}
                                    placeholder={`Select one Lab Test State`}
                                    value={filters.labTestState ? filters.labTestState : null }
                                    maxSelectedOptions={1}
                                    maxViewedOptions={50}
                                    isClearable={true}
                                />
                            </div>
                            <div className={`col-xs-3`}>
                                <label>LAB TEST STATUS</label>
                                <PseudoAsyncSelect
                                    name="labTestStatus"
                                    isMulti={false}
                                    onOptionChange={selectedOptions => {
                                        if(!selectedOptions || selectedOptions.length === 0) {
                                            this.props.setLabTestStatusFilter([]);
                                        }
                                        else{
                                            this.props.setLabTestStatusFilter([selectedOptions]);
                                        }
                                    }}
                                    asyncOptions={() => {
                                       return loadLabTestStatusAPI(5);
                                    }}
                                    placeholder={`Select one Lab Test Status`}
                                    value={filters.testSubmissionStatusIndicator ? filters.testSubmissionStatusIndicator : null }
                                    maxSelectedOptions={1}
                                    maxViewedOptions={50}
                                    isClearable={true}
                                />
                            </div>
                            <div className={`col-xs-3 row`}>
                                <div className={`col-xs-6 action-button`}>
                                    <AsyncButton
                                        name='clearBtn'
                                        onClick={clearFilters}
                                    >
                                        Clear Selection
                                    </AsyncButton>
                                </div>
                                <div className={`col-xs-6 action-button`}>
                                    <AsyncButton
                                        name='searchBtn'
                                        onClick={submitFilters}
                                        loading={this.props.loadingIndicator.isLoadingData}
                                    >
                                        Search
                                    </AsyncButton>
                                </div>
                            </div>
                            <ErrorNotification
                                className={`noSelectedError`}
                                handleClose={closeNotification}
                                messages={[{
                                    title : 'Error',
                                    text  : 'Please select at least one search field'
                                }]}
                                show={this.props.loadingIndicator.noSelected}
                            />
                        </div>
                    </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        filters          : state.filters,
        userInfo         : state.userInfo,
        filtersData      : state.filtersData,
        loadingIndicator : state.loadingIndicator
    };
};

const mapDispatchToProps = {
    setLoadingIndicator,
    setSearchTimeStampAction,
    setSeasonFilter,
    setTestRequestIdFilter,
    setSuppliedMaterialIdentifierFilter,
    setNikePPSItemNumberFilter,
    setTestTypeFilter,
    setMsEndUseFilter,
    setMaterialTypeFilter,
    setSupplierLocationFilter,
    setLabFilter,
    setLabStateTestFilter,
    setLabTestStatusFilter,
    setNoSelectFilter,
    loadDataFromAPI,
    loadDataAction,
    loadCacheDataAction,
    setDataCachedAction,
    setNewSearchAction,
    setRowCount,
    setFilters,
    clearFilterSelection

};

export default connect(mapStateToProps, mapDispatchToProps)(Filters);



// WEBPACK FOOTER //
// ./src/Components/Filters.js